import { pgTable, uuid, date, smallint, text, integer, bigint } from "drizzle-orm/pg-core";
import { pages, sections } from "./sites";

// segmentKey: 'all' / 'new' / 'return' / 'cv' / 'noncv' / 'utm:xxx' / 'exp:<variant_id>'
export const aggPageDaily = pgTable("agg_page_daily", {
  pageId: uuid("page_id").notNull().references(() => pages.id, { onDelete: "cascade" }),
  date: date("date").notNull(),
  device: smallint("device").notNull(),
  segmentKey: text("segment_key").notNull(),
  pv: integer("pv").notNull().default(0),
  sessions: integer("sessions").notNull().default(0),
  goalSessions: integer("goal_sessions").notNull().default(0),
  avgDwellMs: integer("avg_dwell_ms").notNull().default(0),
});

export const aggScrollDaily = pgTable("agg_scroll_daily", {
  pageId: uuid("page_id").notNull().references(() => pages.id, { onDelete: "cascade" }),
  date: date("date").notNull(),
  device: smallint("device").notNull(),
  segmentKey: text("segment_key").notNull(),
  depthPct: integer("depth_pct").notNull(),
  reach: integer("reach").notNull().default(0),
  exits: integer("exits").notNull().default(0),
  dwellMsSum: bigint("dwell_ms_sum", { mode: "number" }).notNull().default(0),
});

export const aggSectionDaily = pgTable("agg_section_daily", {
  pageId: uuid("page_id").notNull().references(() => pages.id, { onDelete: "cascade" }),
  sectionId: uuid("section_id").notNull().references(() => sections.id, { onDelete: "cascade" }),
  date: date("date").notNull(),
  device: smallint("device").notNull(),
  segmentKey: text("segment_key").notNull(),
  reachSessions: integer("reach_sessions").notNull().default(0),
  dwellMsSum: bigint("dwell_ms_sum", { mode: "number" }).notNull().default(0),
  dwellSamples: integer("dwell_samples").notNull().default(0),
  clicks: integer("clicks").notNull().default(0),
  cvClicks: integer("cv_clicks").notNull().default(0),
});

export const aggClickDaily = pgTable("agg_click_daily", {
  pageId: uuid("page_id").notNull().references(() => pages.id, { onDelete: "cascade" }),
  date: date("date").notNull(),
  device: smallint("device").notNull(),
  segmentKey: text("segment_key").notNull(),
  selectorHash: text("selector_hash").notNull(),
  selector: text("selector").notNull(),
  gridX: integer("grid_x").notNull(),
  gridY: integer("grid_y").notNull(),
  clicks: integer("clicks").notNull().default(0),
  cvClicks: integer("cv_clicks").notNull().default(0),
});

export const aggMoveDaily = pgTable("agg_move_daily", {
  pageId: uuid("page_id").notNull().references(() => pages.id, { onDelete: "cascade" }),
  date: date("date").notNull(),
  device: smallint("device").notNull(),
  gridX: integer("grid_x").notNull(),
  gridY: integer("grid_y").notNull(),
  weight: integer("weight").notNull().default(0),
});
